import styled from 'styled-components'
import { Progress } from 'semantic-ui-react';

export const StyledProgressBar = styled(Progress)`
  & > .bar {
    background-color: ${(props: { color: any; }) => props.color || ''} !important;
  }
`;
